"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ACanvasForYourVision() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="230383" id="a-canvas-for-your-vision" className="relative w-full bg-background text-foreground flex flex-col items-center overflow-hidden">
      {}
      <div className="relative w-full h-[60vh] min-h-[500px] lg:h-[75vh]">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683483/img/vow_estate_drone_view.png)] bg-cover bg-center bg-fixed" />
        {}
        <div className="absolute inset-0 bg-primary/5" />
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8 -mt-32 lg:-mt-48 mb-24 lg:mb-32">
        <div ref={textRef} className={`mx-auto max-w-4xl bg-background/80 backdrop-blur-lg border border-border shadow-xl rounded-md p-8 sm:p-12 lg:p-20 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="text-center mb-12">
            <span className="text-secondary font-mono font-medium tracking-widest uppercase text-xs sm:text-sm mb-6 block">
              Ethereal Modernism
            </span>
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-light text-primary mb-8 tracking-tight">
              A Canvas for Your Vision
            </h2>
            <div className="w-12 h-px bg-secondary/40 mx-auto"></div>
          </div>

          <div className="space-y-8 text-lg md:text-xl text-muted-foreground font-default leading-loose md:leading-loose text-center">
            <p>
              VOW is a premium wedding venue offering couples an elegant, customizable setting for their special day. Nestled in a picturesque location, our estate features a spacious ceremony garden and a grand ballroom with contemporary décor.
            </p>
            <p>
              Our dedicated event team provides full-service planning and high-end catering, ensuring every detail reflects your unique story. We accommodate intimate gatherings up to 300 guests with a focus on timeless style and exceptional service.
            </p>
            <p>
              With versatile indoor and outdoor spaces, VOW creates a seamless, luxurious wedding experience. From the first consultation to the final dance, we are committed to creating unforgettable moments that leave lasting impressions.
            </p>
          </div>

          <div className="mt-16 flex justify-center">
            <Button asChild variant="outline" size="lg" className="rounded-md px-8 py-6 text-base font-mono tracking-widest uppercase border-secondary/30 hover:bg-primary hover:text-primary-foreground transition-all duration-300">
              <Link to="/EstatePage">Explore the Estate</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}